import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import Img1 from "../../images/solution/startup/uber.png";
import Img2 from "../../images/solution/startup/pintrest.png";
import Img3 from "../../images/solution/startup/udemy.png";
import { LazyLoadImage } from "react-lazy-load-image-component";

function Brand(props) {
  return (
    <div className="brandsol startup_apps_logo p-100" style={{background:'#F9F9F9'}}>
      <Container>
        <Row>
          <Col xs={12} md={12} lg={9} xl={9} xxl={9} className="m-auto text-center">
            <h2>Some Apps That Broke The Conventional Experience Clutter</h2>
            <div className="brand_box">
              <div className="brand_img ">
                <LazyLoadImage
                  src={Img1}
                  effect="blur"
                  alt="tekrevol_android"
                  className="img-fluid"
                />
              </div>
              <div className="brand_img">
                <LazyLoadImage
                  src={Img2}
                  effect="blur"
                  alt="tekrevol_android"
                  className="img-fluid"
                />
              </div>
              <div className="brand_img">
                <LazyLoadImage
                  src={Img3}
                  effect="blur"
                  alt="tekrevol_android"
                  className="img-fluid"
                />
              </div>
            </div>
            <p>All of the apps mentioned above were mere startups, but they bought something new to the table, making them successful. Today, these apps dominate their digital presence and have established themselves as innovators in the industry.</p>
            <p>Tekrevol aims for the same for your startup app. Over the years, we have created apps for several startup brands that are ruling the industry today. And we would love to do this all over again for you.</p>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Brand;
